<template>
  <div>
    <!--    form Configuration -->
    <form-configuration
      ref="formConfiguration"
      @resetForm="resetForm"
      @switchSendingMode="switchSendingMode"
      @updateConfiguration="updateConfiguration($event)"
    ></form-configuration>
    <!--    form Configuration -->

    <!--    Form Roster-->
    <md-card>
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("progress_report.roster") }}</h4>
        </div>
      </md-card-header>
      <md-card-content>
        <!--        Inputter no review-->
        <form-roster
          v-if="sendingMode === mode.noReview"
          :key="keyInputterNoReview + 'inputter-no-review'"
          ref="inputterNoReviewRefs"
          :staffOpts="staffInputterNoReviewOpts"
          :studentOptsProps="studentInputterNoReviewOpts"
          :type="inputter"
          @batchRemove="batchRemove(inputter)"
          @fetchListAssignStudent="getListAssignStudent($event, inputter)"
          @fetchStaffOptions="setQueryStaffInputterOpts"
          @loadMoreStudent="loadMoreStudent"
          @removeStudent="removeStudent($event, inputter)"
          @showModalAssignStudent="showModalAssignStudent(inputter, $event)"
        ></form-roster>

        <!--        Inputter-->
        <form-roster
          v-if="sendingMode === mode.review"
          :key="keyInputter + 'inputter'"
          ref="inputterReviewRefs"
          :staffOpts="staffInputterOpts"
          :studentOptsProps="studentInputterOpts"
          :type="inputter"
          @batchRemove="batchRemove(inputter)"
          @fetchListAssignStudent="getListAssignStudent($event, inputter)"
          @fetchStaffOptions="setQueryStaffInputterOpts"
          @loadMoreStudent="loadMoreStudent"
          @removeStudent="removeStudent($event, inputter)"
          @showModalAssignStudent="showModalAssignStudent(inputter, $event)"
        ></form-roster>
        <!--        Reviewer-->
        <form-roster
          v-if="sendingMode === mode.review"
          :key="keyReviewer + 'reviewer'"
          ref="reviewRef"
          :staffOpts="staffReviewerOpts"
          :studentOptsProps="studentReviewerOpts"
          :type="review"
          class="pt-10"
          @batchRemove="batchRemove(review)"
          @fetchListAssignStudent="getListAssignStudent($event, review)"
          @fetchStaffOptions="setQueryStaffReviewerOpts"
          @loadMoreStudent="loadMoreStudent"
          @removeStudent="removeStudent($event, review)"
          @showModalAssignStudent="showModalAssignStudent(review, $event)"
        ></form-roster>
      </md-card-content>
    </md-card>
    <!--    Form Roster-->

    <common-modal
      :name="modalNameAssignStudent"
      :primaryAction="primaryAction"
      :title="titleModal"
      height="auto"
      width="80%"
    >
      <template #modal-body>
        <form-assign-student
          ref="assignStudentRefs"
          :currentAuthorized="currentAuthorized"
          :staffIdSelected="staffIdSelected"
        ></form-assign-student>
      </template>
    </common-modal>
  </div>
</template>

<script>
import { service_names } from "@/constants/Services";
import FormRoster from "./Component/FormRoster";
import FormConfiguration from "./Component/FormConfiguration";
import CommonModal from "@/components/Base/CommonModal";
import FormAssignStudent from "./Component/FormAssignStudent";
import { mapActions } from "vuex";
import { getId } from "@/helpers/utils";

const sendingMode = {
  review: "Review",
  noReview: "No-review"
};
const authorized = {
  inputter: "Inputter",
  review: "Review"
};
export default {
  components: { FormAssignStudent, FormConfiguration, FormRoster, CommonModal },
  data() {
    return {
      mode: sendingMode,
      inputter: authorized.inputter,
      review: authorized.review,
      //inputter no review
      keyInputterNoReview: null,
      staffInputterNoReviewOpts: [],
      studentInputterNoReviewOpts: {},

      //inputter
      staffInputterOpts: [],
      studentInputterOpts: {},
      keyInputter: null,
      currentSearchKeyInputter: "",
      currentStatusInputter: "",
      //reviewer
      staffReviewerOpts: [],
      studentReviewerOpts: {},
      keyReviewer: null,
      currentSearchKeyReviewer: "",
      currentStatusReviewer: "",

      //path
      pathGetStaff: `${service_names.user}/progress-setting/setting-student`,
      pathGetStudent: `${service_names.user}/progress-setting/`,
      pathAssignStudent: `${service_names.user}/progress-setting/assign-student`,
      pathRemoveStudent: `${service_names.user}/progress-setting/remove-student`,
      pathBatchRemove: `${service_names.user}/progress-setting/batch-remove-student`,
      pathUpdateSendingMode: `${service_names.user}/progress/update/type-sending-mode/multiple`,
      //
      modalNameAssignStudent: "modalAssignStudents",
      //
      searchQuery: null,
      sendingMode: sendingMode.noReview,
      staffIdSelected: null,
      staffNameSelected: "",
      currentAuthorized: null,
      infoAssignStudent: {
        staffId: null,
        progressId: null,
        type: authorized.inputter
      },
      //
      primaryAction: {
        title: "assign",
        action: this.assignStudent
      }
    };
  },
  computed: {
    titleModal() {
      return (
        (this.currentAuthorized === this.inputter
          ? this.$t("progress_report.assign_inputter")
          : this.$t("progress_report.assign_reviewer")) +
        " " +
        this.staffNameSelected
      );
    }
  },
  methods: {
    ...mapActions("user", ["FetchUserInformation"]),
    loadMoreStudent(limit) {
      this.getListAssignStudent(
        this.infoAssignStudent,
        this.infoAssignStudent.type,
        limit
      );
    },
    async removeStudent({ studentIds, staffIdActivated }, type) {
      const formRequest = {
        type_sending_model: this.sendingMode,
        authorized: type,
        staff_id: staffIdActivated,
        student_ids: studentIds
      };
      await this.$axios.post(this.pathRemoveStudent, formRequest);
      await this.reloadData();
    },
    async reloadData() {
      await this.setQueryStaffInputterOpts(
        this.currentSearchKeyInputter,
        this.currentStatusInputter
      );
      if (this.sendingMode === sendingMode.review)
        await this.setQueryStaffReviewerOpts(
          this.currentSearchKeyReviewer,
          this.currentStatusReviewer
        );
      await this.getListAssignStudent(
        this.infoAssignStudent,
        this.infoAssignStudent.type
      );
    },
    async batchRemove(type) {
      const formRequest = {
        type_sending_model: this.sendingMode,
        authorized: type
      };
      await this.$axios.post(this.pathBatchRemove, formRequest);
      await this.reloadData();
    },
    switchSendingMode(mode) {
      this.sendingMode = mode;
    },
    resetForm(mode) {
      if (this.sendingMode === sendingMode.review) {
        this.staffInputterNoReviewOpts = [];
        this.studentInputterNoReviewOpts = [];
        this.$refs.formConfiguration.form.inputter_no_review_ids = [];
        return;
      }
      this.$refs.formConfiguration.form.inputer_ids = [];
      this.$refs.formConfiguration.form.reviewer_ids = [];
      this.staffInputterOpts = [];
      this.studentReviewerOpts = [];
      this.staffReviewerOpts = [];
      this.studentInputterOpts = [];
      this.keyInputter++;
      this.keyReviewer++;
    },
    buildQueryUpdateType(assignStudentRefs, queryParams) {
      let allStudent = assignStudentRefs.isSelectAllSearchResults;
      if (allStudent) {
        return {
          type_sending_mode: this.sendingMode,
          status: queryParams.status,
          fields: ["student_code", "full_name"],
          search_key: queryParams.search_key,
          program_id: queryParams.program_id,
          grade: queryParams.grade,
          class_ids: queryParams.class_ids
        };
      }
      return {
        type_sending_mode: this.sendingMode,
        student_ids: assignStudentRefs.student_ids
      };
    },
    buildQueryAssign(assignStudentRefs, currentQueryParams) {
      return {
        type_sending_model: this.sendingMode,
        authorized: this.currentAuthorized,
        staff_id: this.staffIdSelected,
        all_student: assignStudentRefs.isSelectAllSearchResults,
        student_ids: assignStudentRefs.student_ids,
        param_get_student: [
          {
            full_name_or_student_code: currentQueryParams.search_key,
            program_id: currentQueryParams.program_id,
            status: currentQueryParams.status,
            grade: currentQueryParams.grade,
            authorized: this.currentAuthorized,
            class_ids: currentQueryParams.class_ids
          }
        ]
      };
    },
    async assignStudent() {
      const assignStudentRefs = this.$refs.assignStudentRefs;
      const currentQueryParams = assignStudentRefs.currentQueryParams;
      const formUpdate = this.buildQueryUpdateType(
        assignStudentRefs,
        currentQueryParams
      );
      const formRequest = this.buildQueryAssign(
        assignStudentRefs,
        currentQueryParams
      );
      await this.$axios.post(this.pathAssignStudent, formRequest);
      await this.$axios.put(this.pathUpdateSendingMode, formUpdate);
      this.$modal.hide(this.modalNameAssignStudent);

      // new thead: dont reload list staff when assign student
      // await this.setQueryStaffInputterOpts(
      //   this.currentSearchKeyInputter,
      //   this.currentStatusInputter
      // );
      // if (this.sendingMode === sendingMode.review)
      //   await this.setQueryStaffReviewerOpts(
      //     this.currentSearchKeyReviewer,
      //     this.currentStatusReviewer
      //   );
      await this.getListAssignStudent(
        this.infoAssignStudent,
        this.infoAssignStudent.type
      );
    },
    async updateConfiguration({ form, isInitSetting }) {
      this.resetForm();
      if (!isInitSetting) {
        await this.$axios.post(this.pathGetStaff, form);
      }
      this.searchQuery = form;
      if (form.type_sending_model === sendingMode.noReview) {
        const response = await this.$axios.get(this.pathGetStaff, form);
        await this.FetchUserInformation();
        if (this.sendingMode === sendingMode.noReview) {
          this.staffInputterNoReviewOpts = this.mapStaffList(
            response.data.data
          );
          return;
        }
        this.staffInputterOpts = this.mapStaffList(response.data.data);
      }
      if (form.type_sending_model === sendingMode.review) {
        await this.FetchUserInformation();
        this.setQueryStaffInputterOpts();
        this.setQueryStaffReviewerOpts();
      }
    },
    saveInfoAssignStudent(staffId, progressId, type) {
      this.infoAssignStudent = Object.assign(this.infoAssignStudent, {
        staffId: staffId,
        progressId: progressId,
        type: type
      });
    },
    getListAssignStudent({ staffId, progressId }, type, limit) {
      if (!progressId) return;
      this.saveInfoAssignStudent(staffId, progressId, type);
      this.staffIdSelected = staffId;
      if (type === authorized.inputter) {
        this.studentReviewerOpts = [];
        this.$refs.reviewRef.staffIdActivated = null;
      } else {
        this.studentInputterOpts = [];
        this.$refs.inputterReviewRefs.staffIdActivated = null;
      }
      this.$axios
        .get(this.pathGetStudent + progressId + "/user", { limit: limit || 50 })
        .then(response => {
          if (this.sendingMode === sendingMode.noReview) {
            this.studentInputterNoReviewOpts = response.data;
            return;
          }
          type === authorized.inputter
            ? (this.studentInputterOpts = response.data)
            : (this.studentReviewerOpts = response.data);
        });
    },

    //list staff inputter
    setQueryStaffInputterOpts(searchKey, status) {
      this.currentSearchKeyInputter = searchKey || "";
      this.currentStatusInputter = status || "";
      const query = {
        limit: 50,
        search_key: this.currentSearchKeyInputter,
        assigned_status: this.currentStatusInputter,
        fields: ["full_name", "staff_id"],
        type_sending_model: this.sendingMode,
        authorized: authorized.inputter,
        authorized_role_id:
          this.sendingMode === sendingMode.review
            ? this.searchQuery?.authorized[0]?.authorized_role_id
            : this.searchQuery.authorized_role_id
      };
      this.getStaffInputterOpts(query);
    },
    async getStaffInputterOpts(query) {
      this.studentInputterOpts = [];
      const response = await this.$axios.get(
        this.pathGetStaff,
        query,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      if (this.sendingMode === sendingMode.noReview) {
        this.staffInputterNoReviewOpts = this.mapStaffList(response.data.data);
        return;
      }
      this.staffInputterOpts = this.mapStaffList(response.data.data);
    },
    //list staff inputter

    mapStaffList(data) {
      return data.map(item => {
        return {
          ...item.staff,
          progressSettingId: getId(item)
        };
      });
    },

    //list staff reviewer
    setQueryStaffReviewerOpts(searchKey, status) {
      this.currentSearchKeyReviewer = searchKey || "";
      this.currentStatusReviewer = status || "";
      const query = {
        limit: 50,
        search_key: searchKey || "",
        assigned_status: this.currentStatusReviewer || "",
        fields: ["full_name", "staff_id"],
        type_sending_model: sendingMode.review,
        authorized: authorized.review,
        authorized_role_id: this.searchQuery?.authorized[1]?.authorized_role_id
      };
      this.getStaffReviewerOpts(query);
    },
    async getStaffReviewerOpts(query) {
      this.studentReviewerOpts = [];
      const response = await this.$axios.get(
        this.pathGetStaff,
        query,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      this.staffReviewerOpts = this.mapStaffList(response.data.data);
    },
    //list staff reviewer

    //show modal
    showModalAssignStudent(type, staffName) {
      this.staffNameSelected = staffName;
      this.currentAuthorized = type;
      this.$modal.show(this.modalNameAssignStudent);
    }
  }
};
</script>
<style lang="scss" scoped></style>
